var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sy-resize-panel',{ref:"container",staticClass:"section",on:{"resize":_vm.handleResize}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }